import { parsePhoneNumber as parsePhoneNumber$1, AsYouType } from 'libphonenumber-js/min';
import omit from 'lodash.omit';

var NUMERIC_REGEX = /[^0-9]/g;
var removeNonNumbers = function removeNonNumbers(value) {
  return value.replace(NUMERIC_REGEX, '');
};
/**
 * Parses the passed phone string, make sure to prepend country code to the string before passing.
 * e.g. +61 1900 654 321, +611900654321, +1-613-555-0192 etc.
 * Please refer https://gitlab.com/catamphetamine/libphonenumber-js#parse-phone-number
 *
 * @returns object or passed value as is if number is not valid
 */

var parsePhoneNumber = function parsePhoneNumber(value) {
  try {
    // https://gitlab.com/catamphetamine/libphonenumber-js#parse-phone-number
    var phoneNumber = parsePhoneNumber$1(value); // https://gitlab.com/catamphetamine/libphonenumber-js#ispossible-boolean
    // Checks if the phone number is "possible". Only checks the phone number length,
    // doesn't check the actual phone number digits against any regular expressions.

    if (phoneNumber.isPossible()) {
      return phoneNumber;
    } // eslint-disable-next-line no-empty

  } catch (_unused) {}

  return value;
};
var formatPhone = function formatPhone(value) {
  var numbers = removeNonNumbers(value);

  if (numbers.length > 10) {
    return "".concat(numbers.substring(0, 1), " (").concat(numbers.substring(1, 4), ") ").concat(numbers.substring(4, 7), "-").concat(numbers.substring(7));
  } else if (numbers.length > 6) {
    return "(".concat(numbers.substring(0, 3), ") ").concat(numbers.substring(3, 6), "-").concat(numbers.substring(6));
  } else if (numbers.length > 3) {
    return "(".concat(numbers.substring(0, 3), ") ").concat(numbers.substring(3, 6));
  }

  return numbers;
};
var formattersByCountry = {};
var formatPhoneInternational = function formatPhoneInternational(country, value) {
  if (!(country in formattersByCountry)) {
    formattersByCountry[country] = new AsYouType(country);
  }

  var formatter = formattersByCountry[country];

  if (typeof formatter === 'undefined') {
    return null;
  }

  var formattedOutput = formatter.input(value);
  var number = omit(formatter.getNumber(), ['metadata']);
  var template = formatter.getTemplate();
  formatter.reset();
  return {
    formattedOutput: formattedOutput,
    number: number,
    template: template
  };
};

export { formatPhone, formatPhoneInternational, parsePhoneNumber, removeNonNumbers };
